/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { memo } from 'react';

import { ServiceType } from 'shared';

import { PageOverlay } from '../../../../../../components/PageOverlay/PageOverlay';
import { ClusterConfiguration } from '../../../../../../types/cluster/ClusterConfiguration';
import { UpdateClusterDetailsParameterIdentification } from '../../../../../../types/cluster/UpdateClusterDetailsParameterIdentification';
import { ChangePlanForm } from '../ChangePlanForm/ChangePlanForm';

type ChangeClusterPlanOverlayProps = {
  isOpen: boolean;
  closeOverlay: () => void;
  currentConfig: ClusterConfiguration & { serviceType: ServiceType };
  maintenanceWindows: string[];
  identificationData: UpdateClusterDetailsParameterIdentification;
};

export const ChangeClusterPlanOverlay = memo<ChangeClusterPlanOverlayProps>(props => {
  const { isOpen, closeOverlay, currentConfig, maintenanceWindows, identificationData } = props;

  return (
    <PageOverlay
      open={isOpen}
      classes={{ childrenBlock: 'd-flex' }}
      showCloseBtn
      onCloseBtnClick={closeOverlay}
      disableRestoreFocus
      name="change-cluster-plan"
    >
      {isOpen ? (
        <ChangePlanForm
          currentConfig={currentConfig}
          maintenanceWindows={maintenanceWindows}
          isOpened={isOpen}
          identificationData={identificationData}
          closeOverlay={closeOverlay}
        />
      ) : null}
    </PageOverlay>
  );
});
